import React, { useState, useEffect } from "react";
import Header_Home from "../Component/Header_Home";
import Header from "../Component/Header";
import "../Payment/payment-styles.css";
import { Box, Typography, Grid, Paper, Button, Divider } from "@mui/material";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
import { useLocation } from "react-router-dom";
import CreditCardIcon from "@mui/icons-material/CreditCard";
import QrCodeIcon from "@mui/icons-material/QrCode";
import ReceiptIcon from "@mui/icons-material/Receipt";
import { payment } from "./PaymentService/paymentService";
import { useNavigate } from "react-router-dom";
import CircularProgress from "@mui/material/CircularProgress";
import Backdrop from "@mui/material/Backdrop";
import { Col } from "react-bootstrap";
import Row from "react-bootstrap/Row";
import { getParameterAPI } from "../PolicyDetail/PolicyDetailService/policyDetailService";
import {
  getPolicyDetailAPI,
  getDataByReferenceID,
  getDataPlanCode,
} from "../Payment/PaymentService/paymentService";
import CryptoJS from "crypto-js";
import moment from "moment";
import {
  policyLoanEnquiry,
} from "../PolicyDebt/PolicyDebtService/policyDebtService";

const Payment = (props) => {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const location = useLocation();
  // const paymentData = location.state || {};
  const [paymentData, setPaymentData] = useState(location.state || {});
  const { rcData, policyDebt, radioAmt, paymentDebtDate, debtAmt } =
    location.state || {};
  const navigate = useNavigate();
  const [policyNoText, setPolicyNoText] = useState(paymentData.policyNo);
  const [paymentDueDateText, setPaymentDueDateText] = useState(
    paymentData.policyDueDate
  );
  const [policyPaymentAllowDate, setPaymentEffectiveDateText] = useState(
    paymentData.policyPaymentAllowDate
  );
  const [policyRemainPremiumAmount, setPolicyRemainPremiumAmount] = useState(
    paymentData.policyRemainPremiumAmount
  );
  const [planCode, setPlanCode] = useState(localStorage.getItem("planCode"));
  const [configPlan, setConfigPlan] = useState();

  const [loading, setLoading] = useState(false);
  const {
    dataLoanEnquiry = JSON.parse(
      localStorage.getItem("dataLoanEnquiry") || "{}"
    ),
  } = location.state || {};
  const { premium } = location.state || {};

  const [formData, setFormData] = useState({
    reference_number: paymentData.policyNumber || "",
    payment_method: "",
    amount: paymentData.premiumAmount || "",
    client_code: "CLIENT_CODE", // ปรับตามที่ต้องการ
    signature: "",
  });
  const [cusTel, setCusTel] = useState("");
  const [policyData, setPolicyData] = useState("");
  const paymentDueDateTextFormat = moment(
    paymentDueDateText,
    ["DD/MM/YYYY", "YYYY-MM-DD"],
    true
  );

  const paymentDueDateTextFormatPlus30 = paymentDueDateTextFormat.isValid()
    ? paymentDueDateTextFormat.add(30, "days").format("DD/MM/YYYY")
    : "-";

  const [spinner, setSpinner] = useState(true);
  const [paymentType, setPaymentType] = useState("");
  const [loanAmt, setLoanAmt] = useState();
  const [debtDate, setDebtDate] = useState();
  const now = new Date();
  const day = String(now.getDate()).padStart(2, "0");
  const month = String(now.getMonth() + 1).padStart(2, "0");
  const year = now.getFullYear() + 543;
  const todayDate = `${day}/${month}/${year}`;
  const [payOption, setPayOption] = useState();
  const [dataLoanEnquiryBack, setDataLoanEnquiryBack] = useState("");

  useEffect(() => {
    if (policyDebt == "policyDebt") {
      setSpinner(false);
      // getDataBackPayment();
      policyLoanEnquiryAPI();
    } else {
      if (paymentData.policyNo == undefined) {
        getDataBackPayment();
        
      } else {
        setSpinner(false);
      }
    }
    getTel();
    getDataPlanCodeApi();
    console.log(dataLoanEnquiry);
    console.log(paymentData);
    console.log(policyDebt);
    console.log(radioAmt);
    console.log(premium);
  }, [
    policyNoText,
    paymentDueDateText,
    policyPaymentAllowDate,
    policyRemainPremiumAmount,
    paymentData,
    configPlan,
  ]);

  const createAndSubmitForm = (formData) => {
    const form = document.createElement("form");
    form.action = process.env.REACT_APP_PAYMENT_LINK;
    form.method = "POST";
    form.style.display = "none";

    Object.keys(formData).forEach((key) => {
      const input = document.createElement("input");
      input.type = "hidden";
      input.name = key;
      input.value = formData[key];
      form.appendChild(input);
    });

    document.body.appendChild(form);
    form.submit();
  };

  const handleLoading = () => {
    setLoading(!loading);
  };

  const clickPayment = async (methodType) => {
    var json = {};
    console.log("[clickPayment] paymentData:", paymentData);
    console.log("[clickPayment] rcData:", rcData);
    if (policyDebt === "policyDebt") {
      const insuredName = `${rcData.firstName || ""} ${rcData.lastName || ""}`.trim();
      console.log("[clickPayment] paymentInsuredName (policyDebt):", insuredName, "| source: rcData.firstName=", rcData.firstName, "rcData.lastName=", rcData.lastName);
      json = {
        policyNo: rcData.policyNo,
        paymentMethod: methodType,
        paymentInsuredName: insuredName,
        amount: debtAmt,
        paymentDueDate: rcData.policyDueDate,
        policyEffectiveDate: rcData.policyEffectiveDate,
        loanAmount: debtAmt,
        paymentType: "LOAN",
        paymentOption: radioAmt,
      };
    } else {
      const insuredName = `${paymentData.firstName || ""} ${paymentData.lastName || ""}`.trim();
      console.log("[clickPayment] paymentInsuredName (premium):", insuredName, "| source: paymentData.firstName=", paymentData.firstName, "paymentData.lastName=", paymentData.lastName);
      json = {
        policyNo: paymentData.policyNo,
        paymentMethod: methodType,
        paymentInsuredName: insuredName,
        amount: paymentData.policyRemainPremiumAmount,
        paymentDueDate: paymentData.policyDueDate,
        policyEffectiveDate: paymentData.policyEffectiveDate,
        loanAmount: null,
        paymentType: "PREMIUM",
        paymentOption: null,
      };
    }

    handleLoading();

    console.log("[clickPayment] paymentInsuredName:", json.paymentInsuredName);
    console.log("[clickPayment] payload:", json);
    const result = await payment(json);
    console.log(result);
    if (result.success) {
      const {
        paymentType,
        payload: {
          loanAmount,
          amount,
          reference_number,
          paymentMethod,
          client_code,
          signature,
        },
      } = result;
      const formattedAmount = parseFloat(
        paymentType === "LOAN" ? loanAmount : amount
      ).toFixed(2);

      const newFormData = {
        reference_number,
        payment_method: paymentMethod,
        amount: formattedAmount,
        client_code,
        signature,
      };

      setFormData(newFormData);
      handleLoading();
      createAndSubmitForm(newFormData);
    }
  };

  const formatCurrency = (num) => {
    // console.log(num);
    if (num != undefined) {
      return num
        .toLocaleString("en-US", { style: "currency", currency: "USD" })
        .replace("$", "");
    }
  };

  const goToPolicyList = () => {
    navigate("/policylist");
  };

  const getTel = async () => {
    const result = await getParameterAPI(12);
    const payload = result.payload;
    const cusTel = payload.find((item) => item.code === "CUS_SERV_TEL");
    const variable1 = cusTel.variable1;
    setCusTel(variable1);
  };

  const decryptCardNumber = (encryptedCardNumber, secretKey) => {
    const bytes = CryptoJS.AES.decrypt(encryptedCardNumber, secretKey);
    const decrypted = bytes.toString(CryptoJS.enc.Utf8);
    return decrypted;
  };

  const policyLoanEnquiryAPI = async () => {
    const urlParams = new URLSearchParams(window.location.search);
    const policyNo = urlParams.get("policyNo");
    const result = await policyLoanEnquiry(policyNo);
    // setLoadingContent(false);
    setDataLoanEnquiryBack(result.data);
    console.log(result.data);
    // setMinimumPayAmt(
    //   result.data.interestAmount + result.data.interestAplAmount
    // );
    // setTotalDebt(
    //   CurrencyFormater(result.data.totalLoanAmount + result.data.totalAplAmount)
    // );
    
    // console.log(result.data);
  };

  const getDataBackPayment = async () => {
    // setLoading(!loading);
    // alert("Test")
    // setSpinner(true);
    const urlParams = new URLSearchParams(window.location.search);
    const referenceNumber = urlParams.get("referenceNumber");
    // console.log(referenceNumber);
    const resultRef = await getDataByReferenceID(referenceNumber);
    // console.log(resultRef.payload.policyNo);

    const resultPolicy = await getPolicyDetailAPI(
      resultRef.payload.policyNo,
      decryptCardNumber(
        localStorage.getItem("customer_id"),
        process.env.REACT_APP_ENCRYPT_DATA
      )
    );

    // console.log(resultPolicy);

    setPolicyNoText(resultPolicy.data.policyNo);
    setPaymentDueDateText(resultPolicy.data.policyDueDate);
    setPaymentEffectiveDateText(resultPolicy.data.policyPaymentAllowDate);
    setPolicyRemainPremiumAmount(resultPolicy.data.policyRemainPremiumAmount);
    setPaymentData(resultPolicy.data);
    setPaymentType(resultRef.payload.paymentType);
    setLoanAmt(resultRef.payload.loanAmount);
    setDebtDate(todayDate);
    setPayOption(resultRef.payload.paymentOption);
    setTimeout(() => {
      // setSpinner(false);
      // handleLoading()
      setSpinner(!spinner);
    }, 1000);

    // console.log(resultPolicy.data);
  };

  const getDataPlanCodeApi = async () => {
    // setSpinner(true)
    const result = await getDataPlanCode(planCode);
    console.log(result.data.length);
    setConfigPlan(result.data.length);
    // setSpinner(false)
  };

  const loanAmount = dataLoanEnquiry.loanAmount ?? dataLoanEnquiryBack.loanAmount;
  const aplAmount = dataLoanEnquiry.aplAmount ?? dataLoanEnquiryBack.aplAmount;

  const showCard = policyDebt === "policyDebt" ? (loanAmount === 0 && aplAmount > 0) : (configPlan > 0);
  const showQR = policyDebt !== "policyDebt" || loanAmount > 0 || (loanAmount === 0 && aplAmount > 0);

  const paymentMethodCount = [showCard, showQR].filter(Boolean).length;
  const justifyClass =
    paymentMethodCount === 1
      ? "justify-content-start"
      : "justify-content-around";

  return (
    <>
      <Header_Home />
      <Header
        title={
          policyDebt === "policyDebt" || paymentType === "LOAN"
            ? "ชำระคืนเงินกู้ตามกรมธรรม์"
            : "ชำระเบี้ยประกัน"
        }
      />
      {spinner && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            backgroundColor: "rgba(255, 255, 255, 0.8)",
            zIndex: 9999,
          }}
        >
          <CircularProgress
            sx={{
              animationDuration: "550ms",
            }}
            color="inherit"
          />
        </div>
      )}
      {loading && (
        <Backdrop
          sx={{
            color: "#fff",
            zIndex: (theme) => theme.zIndex.drawer + 1,
          }}
          open={loading}
        >
          <CircularProgress
            sx={{
              animationDuration: "550ms",
            }}
            color="inherit"
          />
        </Backdrop>
      )}
      <div className="containers" style={{ paddingBottom: 95 }}>
        {policyDebt === "policyDebt" || paymentType === "LOAN" ? (
          <Paper
            elevation={3}
            style={{
              border: "1px solid #f2654e",
              borderRadius: "12px",
              padding: "20px",
              margin: "20px",
            }}
          >
            <Grid container spacing={2}>
              <Grid item xs={6}>
                <Typography style={{ fontSize: 14, fontWeight: "bold" }}>
                 เงินกู้ตามกรมธรรม์ที่รอการชำระ ณ วันที่
                </Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography
                  style={{
                    fontSize: 16,
                    fontWeight: "bold",
                    textAlign: "right",
                  }}
                >
                  {paymentDebtDate || debtDate}
                </Typography>
              </Grid>

              <Grid item xs={6}>
                <Typography style={{ fontSize: 14, fontWeight: "bold" }}>
                  จำนวนเงิน
                </Typography>
                <Typography style={{ fontSize: 12, color: "#f2654e" }}>
                  (
                  {radioAmt === "full" || payOption === "full"
                    ? "ชำระเต็มจำนวน"
                    : radioAmt === "minimum" || payOption === "minimum"
                    ? "ชำระขั้นต่ำ"
                    : "ชำระระบุจำนวน"}
                  )
                </Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography
                  style={{
                    fontSize: 16,
                    fontWeight: "bold",
                    textAlign: "right",
                  }}
                >
                  {formatCurrency(debtAmt || loanAmt)}
                </Typography>
              </Grid>
            </Grid>
          </Paper>
        ) : (
          // ถ้าไม่ใช่ policyDebt ให้แสดงแบบเดิม
          <Paper
            elevation={3}
            className="paper"
            style={{
              marginTop: "20px",
              marginLeft: "20px",
              marginRight: "20px",
            }}
          >
            <Grid container spacing={2}>
              <Grid item xs={6}>
                <Typography
                  style={{ fontSize: 13 }}
                  className={`label ${isSmallScreen ? "small" : ""}`}
                >
                  กรมธรรม์เลขที่
                </Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography
                  style={{ fontSize: 13 }}
                  className={`value ${isSmallScreen ? "small" : ""}`}
                >
                  {policyNoText}
                </Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography
                  style={{ fontSize: 13 }}
                  className={`label ${isSmallScreen ? "small" : ""}`}
                >
                  วันที่ครบกำหนดชำระ
                </Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography
                  style={{ fontSize: 13 }}
                  className={`value ${isSmallScreen ? "small" : ""}`}
                >
                  {paymentDueDateText}
                </Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography
                  style={{ fontSize: 13 }}
                  className={`label ${isSmallScreen ? "small" : ""}`}
                >
                  ชำระได้ถึงวันที่
                </Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography
                  style={{ fontSize: 13 }}
                  className={`value ${isSmallScreen ? "small" : ""}`}
                >
                  {policyPaymentAllowDate}
                </Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography
                  style={{ fontSize: 13 }}
                  className={`label ${isSmallScreen ? "small" : ""}`}
                >
                  ค่าเบี้ยประกัน
                </Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography
                  style={{ fontSize: 13 }}
                  className={`value ${isSmallScreen ? "small" : ""}`}
                >
                  {formatCurrency(policyRemainPremiumAmount)}
                </Typography>
              </Grid>
            </Grid>
          </Paper>
        )}

        <p
          style={{
            marginLeft: "20px",
            marginRight: "20px",
            marginTop: "25px",
            color: "#f44336",
            fontSize: 18,
          }}
        >
          ช่องทางการชำระ
        </p>
        <Box
          className="payment-options"
          style={{ marginLeft: "20px", marginRight: "20px" }}
        >
          <Box className="d-flex flex-row">
            <Box className="d-flex flex-column w-100">
              <Typography variant="h6" className="label" color="textPrimary">
                ออนไลน์
              </Typography>

              <Box
                style={{ marginLeft: "40px" }}
                className={`d-flex flex-row ${justifyClass}`}
              >
                {/* บัตรเครดิต: เฉพาะกรณี configPlan > 0 และตรงเงื่อนไขตาม policyDebt */}
                {showCard && (
                  <Box
                    className="payment-option"
                    onClick={() => clickPayment("card")}
                  >
                    <CreditCardIcon />
                    <Typography
                      className="set-font text-black"
                      style={{ fontSize: 13 }}
                    >
                      บัตรเครดิต
                    </Typography>
                  </Box>
                )}

                {/* QR Code */}
                {showQR && (
                  <Box
                    className="payment-option"
                    onClick={() => clickPayment("qr")}
                  >
                    <QrCodeIcon style={{ color: "#e53935" }} />
                    <Typography
                      className="set-font text-black"
                      style={{ fontSize: 13 }}
                    >
                      QR PromptPay
                    </Typography>
                  </Box>
                )}
              </Box>
            </Box>

            {/* <Box className="d-flex flex-column align-items-center w-50">
              <Typography variant="h6" className="label" color="textPrimary">
                อื่นๆ
              </Typography>
              <Box className="payment-option">
                <ReceiptIcon />
                <Typography
                  className="set-font text-black"
                  style={{ fontSize: 13 }}
                >
                  Bill Payment
                </Typography>
              </Box>
            </Box> */}
          </Box>
          {/* {((policyDebt !== "policyDebt" || policyDebt == undefined) &&
            paymentType === "PREMIUM") ||
            (premium === "PREMIUM" && (
              <Typography
                className="payment-notice"
                style={{ paddingTop: "30px" }}
              >
                **หากเกินวันที่ {policyPaymentAllowDate} เวลา 16.00 น.
                กรุณาติดต่อชำระได้ที่ฝ่ายลูกค้าสัมพันธ์ {cusTel} หรือ ไลน์ไอดี
                @rabbit_life
              </Typography>
            ))}
          {showQR && (
            <Typography
              className="payment-notice"
              style={{ paddingTop: "30px" }}
            >
              **เนื่องจากแบบประกันนี้ มีค่าธรรมเนียมจากการชำระผ่านบัตรเครดิต 
              หากท่านประสงค์จะชำระ สามารถติดต่อที่ฝ่ายลูกค้าสัมพันธ์ {cusTel} หรือ ไลน์ไอดี
              @rabbit_life
            </Typography>
          )} */}
          {showQR && !showCard && (
            <Typography
              className="payment-notice"
              style={{ paddingTop: "30px" }}
            >
              **เนื่องจากการชำระเงินกู้ตามกรมธรรม์ มีค่าธรรมเนียมจากการชำระผ่านบัตรเครดิต หากท่านประสงค์จะชำระ 
              สามารถติดต่อที่ฝ่ายลูกค้าสัมพันธ์ {cusTel} หรือ ไลน์ไอดี @rabbit_life
            </Typography>
          )}

          {showQR && showCard && (
            <Typography
              className="payment-notice"
              style={{ paddingTop: "30px" }}
            >
              **หากเกินวันที่ {policyPaymentAllowDate} เวลา 16.00 น.
              กรุณาติดต่อชำระได้ที่ฝ่ายลูกค้าสัมพันธ์ {cusTel} หรือ ไลน์ไอดี
              @rabbit_life
            </Typography>
          )}
        </Box>
        <Grid
          container
          spacing={1}
          className="justify-content-center flex-wrap"
        >
          <Grid item xs={12} sm={6}>
            <button
              onClick={goToPolicyList}
              className="btn-checkout-back w-100 p-2 bold"
            >
              ย้อนกลับ
            </button>
          </Grid>
        </Grid>
      </div>
    </>
  );
};

export default Payment;
